<main class="login-page">
  <section class="login-panel">
    <img src="/tops-logo-white.png" alt="TOPS Logo" />
    <h1>TOPS Offline</h1>
    <p>Sign in with your Microsoft account to continue.</p>
    @if (errorMessage) {
      <div class="login-error" role="alert">{{ errorMessage }}</div>
    }
    <button type="button" (click)="signIn()" [disabled]="signingIn">
      {{ signingIn ? 'Redirecting...' : 'Sign in with Microsoft' }}
    </button>
  </section>
</main>